<template>
<div>
   <label class="sr-only" for="inline-form-input-name">  انتخاب کاربر</label>

  <a-select
    mode="multiple"
    label-in-value
    :value="value"
    placeholder="جستجوی کاربران..."
    style="width: 100%"
    :filter-option="false"
    :not-found-content="fetching ? undefined : null"
    @search="fetchUser"
    @change="handleChange"
  >
    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
    <a-select-option v-for="d in users" :key="d.id">
      {{ d.firstname+' '+d.lastname +'  #'+d.id }}
    </a-select-option>
  </a-select>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';

export default {
  data() {
    this.lastFetchId = 0;
    this.fetchUser = debounce(this.fetchUser, 800);
    return {
      data: [],
      value: [],
      users: [],
      fetching: false,
      page:1,
      stopCall:false,
    };
  },
  methods: {
    fetchUser(value) {
      var vm = this;
        this.fetching = true;
        if(value.length > 0){
          vm.page = 1;
          vm.stopCall = false;
          vm.users=[];
        }
        if (vm.page == 1) {
            this.getUserAxios(value);
        setInterval(function () {
            if (vm.stopCall === false && vm.page !== 1) {
                vm.getUserAxios(value);
            }
        }, 2000);
        }
    },
    handleChange(value) {
          this.stopCall=true;

const filter=value.map((el) => {
    return el.key;
  
});
     this.$emit('ids', filter);
          Object.assign(this, {
          value,
          data: [],
          fetching: false,
        });
    },
    getUserAxios(value) {
            var vm = this;
            vm.fetching = true;
            let url = `/users/all?page=${this.page}&&keyword=${value}`;
            axios
                    .get(url)
                    .then(function (response) {
                    vm.users = [...vm.users, ...response.data.data];
                  
                    if (vm.page >= response.data.last_page) {
                        vm.stopCall = true;
                    }
                    vm.page = vm.page + 1;
                    vm.fetching = false;
            });
        },  
  },
};
</script>
